(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Layout", [], factory);
	else if(typeof exports === 'object')
		exports["Layout"] = factory();
	else
		root["Layout"] = factory();
})(this, function() {
return 